import { FormFieldEnums } from "shared/types/enums";
import ButtonInput from "shared/components/forms/buttons/ButtonInput";
import SubmitButton from "./SubmitNextButton";

const SkipButtonGroup = ({
  onSkipHandler,
  isLastStep,
}: {
  onSkipHandler: () => void;
  isLastStep: boolean;
}) => (
  <div className="skippable-container">
    <ButtonInput
      id="skip-button"
      type={FormFieldEnums.Button}
      className="skip-button"
      label="Skip"
      onClick={onSkipHandler}
    />
    <SubmitButton isLastStep={isLastStep} />
  </div>
);

export default SkipButtonGroup;
